module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Regular-WebM-128e4251d1a7024025f8f77aabcc41fb.woff2";